import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';

import { ApiService } from '../../core/api';
import { List, ResponseDatas } from '../../core/api/types';
import { FeatureDetailsHomeCharging, FeatureDetailsHomeChargingLocation } from '../features';

import {
  GetReportsParams,
  HomeChargingAddUsersResult,
  HomeChargingEmployee,
  HomeChargingRemoveUserPayload,
  HomeChargingReport,
  HomeChargingReportFilters
} from './types';

@Injectable({
  providedIn: 'root'
})
export class HomeChargingService {
  constructor(private readonly apiService: ApiService) {}

  addEmployees(featureClientID: number, employees: HomeChargingEmployee[]): Observable<HomeChargingAddUsersResult> {
    return this.apiService
      .post<ResponseDatas<HomeChargingAddUsersResult>>(`home-charging/${featureClientID}/add`, employees)
      .pipe(map((result) => result?.datas));
  }

  deleteEmployee(
    featureClientID: number,
    location: FeatureDetailsHomeChargingLocation,
    payload: HomeChargingRemoveUserPayload
  ): Observable<void> {
    return this.apiService.delete(`home-charging/${featureClientID}/remove/${location.CompanyUserID}`, {
      body: payload
    });
  }

  downloadReport(reportID: number): Observable<Blob> {
    return this.apiService.get(`home-charging/report/${reportID}/download`, { observe: 'body', responseType: 'blob' });
  }

  getReportFilters(homeChargingID: number): Observable<HomeChargingReportFilters> {
    return this.apiService
      .get<ResponseDatas<HomeChargingReportFilters>>(`home-charging/reports/${homeChargingID}/filters`)
      .pipe(map((result) => result?.datas));
  }

  getReports(homeChargingID: number, params: GetReportsParams): Observable<List<HomeChargingReport>> {
    return this.apiService
      .get<
        ResponseDatas<List<HomeChargingReport>>
      >(`home-charging/reports/${homeChargingID}`, { params: new HttpParams({ fromObject: params }) })
      .pipe(map((result) => result?.datas));
  }

  sendReport(reportID: number): Observable<void> {
    return this.apiService.post(`home-charging/report/${reportID}/send`, {});
  }

  updateFeatureDetails(featureDetails: FeatureDetailsHomeCharging): Observable<FeatureDetailsHomeCharging> {
    return this.apiService.put('home-charging', featureDetails);
  }
}
